import { useWindowDocumentTitle } from '~/lib/useWindowDocumentTitle';
import { useGradeConversionPageProps } from '../../data/useGradeConversionPageProps';
import { ErrorHandler, ErrorPage } from '../ErrorPage';
import { LoadingPage } from '../LoadingPage';
import { GradeConversionProvider } from './context';
import { GradeConversionLayout } from './layouts';

export function GradeConversionPage() {
  useWindowDocumentTitle('Grade Conversion');
  const { initialProps, isLoadingInitialProps, isInitialPropsError, initialPropsError } = useGradeConversionPageProps();

  if (!isInitialPropsError && isLoadingInitialProps) {
    return <LoadingPage />;
  }
  if (isInitialPropsError) {
    return <ErrorHandler error={initialPropsError} />;
  }
  if (!initialProps) {
    return <ErrorPage customMessage="Failed to fetch page props." />;
  }

  return (
    <GradeConversionProvider initialProps={initialProps}>
      <GradeConversionLayout />
    </GradeConversionProvider>
  );
}
